/**
 * 
 */
import { EducationContractShort } from './educationContractShort.model';
import { EducationContractDocument } from './educationContractDocument.model';
export class EducationContract extends EducationContractShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public document: EducationContractDocument[]; /*Документы*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.document = [];
        if (json.document) {
          for (const i in json.document) {
            if ( json.document.hasOwnProperty( i ) ) {
                this.document.push(new EducationContractDocument(json.document[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
